import { render } from "./ModulesElement.vue?vue&type=template&id=b28cca1e&scoped=true&ts=true"
import script from "./ModulesElement.vue?vue&type=script&lang=ts"
export * from "./ModulesElement.vue?vue&type=script&lang=ts"

import "./ModulesElement.vue?vue&type=style&index=0&id=b28cca1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28cca1e"]])

export default __exports__